import React from 'react';
import { currencyFormatter } from 'shared/utils/currencyFormatter';
import { displayAnnualAmount } from 'Quotes/utils/priceDisplay';

interface PriceSummarySegmentProps {
  label: string;
  value: number;
  suffix?: string;
  viewAsMonthly?: boolean;
}

const PriceSummarySegment: React.FC<React.PropsWithChildren<PriceSummarySegmentProps>> = ({
  label,
  value,
  suffix = '',
  viewAsMonthly = false,
  children,
}) => {
  return (
    <div className="price-summary__segment-wrapper">
      <div className="segment_label pl-2">
        <small>
          {label} {currencyFormatter.format(displayAnnualAmount(value, viewAsMonthly) ?? 0)}{' '}
          {viewAsMonthly && suffix === 'per year' ? 'per month' : suffix} {children}
        </small>
      </div>
    </div>
  );
};

export default PriceSummarySegment;
